import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { SitesRouteNames, SitesRoutePathNames } from '../../enums';
import { beforeEnter } from './../guards';

const Component = () => import('./StationSchedule.vue');

export default {
  path: buildChildURL(
    SitesRoutePathNames.SITE,
    SitesRoutePathNames.STATION_SCHEDULE,
    SitesRoutePathNames.STATION,
  ),
  name: SitesRouteNames.SITE_STATION_SCHEDULE,
  component: Component,
  beforeEnter: beforeEnter,
} as RouteRecordRaw;
